var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"siterank",staticStyle:{"width":"100%","height":"240px"}}),_c('Edialog',{attrs:{"show":_vm.show,"info":_vm.info},on:{"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }